export default "__VITE_ASSET__DK2TJW_t__"